import { Link } from "react-router-dom";

export default function ContactCta() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6">
      <div className="relative overflow-hidden rounded-3xl">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20banner%20with%20golden%20and%20rose%20soft%20light%20particles%20and%20film%20bokeh%2C%20inviting%20creative%20entertainment%20atmosphere%2C%20minimal%20modern%20design&width=1400&height=520&seq=cta-banner-01&orientation=landscape"
          alt="联系我们背景"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-700/90 via-primary-600/70 to-accent-500/60"></div>
        <div className="relative flex flex-col items-start gap-6 p-8 md:p-12 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-xl">
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
              有新鲜的瓜想分享？欢迎投稿
            </h2>
            <p className="mt-3 text-sm leading-6 text-background-50/90">
              掌握一手圈内资讯、拍到精彩现场画面？告诉我们，一经采用即署名推荐。也欢迎通过联系我们反馈意见与版权问题。
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 transition hover:bg-accent-400 hover:text-background-50"
            >
              <i className="ri-upload-2-line" /> 立即投稿
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full px-6 py-3 text-sm font-semibold text-background-50 ring-1 ring-inset ring-background-50/50 transition hover:bg-background-50/10"
            >
              <i className="ri-customer-service-line" /> 联系我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}